import { Box, Typography } from "@mui/material";

/** 一覧の読み込みに失敗し、表示できる結果が無いときの文言 */
export const STORED_LIST_LOAD_ERROR_MESSAGE =
  "一覧の読み込みに失敗しました。しばらく経ってから「この条件で検索」を押してください。";

/** 取得済商業登記の一覧を一度も読み込めなかったときに、結果欄へ出す表示 */
export const StoredListLoadError: React.FC = () => (
  <Box sx={{ py: 6, textAlign: "center" }}>
    <Typography color="error">{STORED_LIST_LOAD_ERROR_MESSAGE}</Typography>
  </Box>
);
